import { NODE_ENV } from "@/common/config";

class Logger {
  private isProd = NODE_ENV === "production";

  private shouldLog(): boolean {
    return !this.isProd;
  }

  log(message: string, ...args: unknown[]): void {
    if (this.shouldLog()) {
      console.log(message, ...args);
    }
  }

  warn(message: string, ...args: unknown[]): void {
    if (this.shouldLog()) {
      console.warn(message, ...args);
    }
  }

  error(message: string, ...args: unknown[]): void {
    // Always log errors, even in production
    console.error(message, ...args);
  }

  info(message: string, ...args: unknown[]): void {
    if (this.shouldLog()) {
      console.info(message, ...args);
    }
  }

  debug(message: string, ...args: unknown[]): void {
    if (this.shouldLog()) {
      console.debug(message, ...args);
    }
  }
}

export const logger = new Logger();
